import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { ArrowLeft, ShieldCheck, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";

export default function Charter() {
  const nav = useNavigate();
  const [ok, setOk] = useState(false);

  const rules = [
    "Je réponds rapidement et honnêtement aux demandes locales.",
    "Je respecte les particuliers, mes engagements et les délais annoncés.",
    "Je fournis un devis clair avant tout démarrage de chantier.",
    "Je m'engage à ne pas contourner la plateforme après un premier contact.",
  ];

  return (
    <div className="app-shell grain-bg flex flex-col">
      <header className="px-5 py-4 flex items-center gap-3 border-b border-border">
        <button onClick={() => nav("/onboarding")} className="tap-scale" data-testid="charter-back-btn">
          <ArrowLeft className="w-5 h-5" />
        </button>
        <h2 className="font-heading font-bold text-lg">Charte Pro</h2>
      </header>

      <div className="px-5 py-6 space-y-5 pb-32">
        <div className="rounded-2xl bg-pro/5 border border-pro/30 p-4 flex items-start gap-3">
          <ShieldCheck className="w-6 h-6 text-pro mt-0.5 shrink-0" />
          <div>
            <div className="font-heading font-bold text-ink">Rejoindre Besoin d&apos;un Pro</div>
            <p className="text-xs text-slate2 leading-relaxed mt-1">
              Vous rejoignez une communauté d&apos;artisans locaux vérifiés.
              Pour préserver la qualité du réseau, chaque pro s&apos;engage à respecter ces règles simples.
            </p>
          </div>
        </div>

        <div className="rounded-2xl bg-white border border-border p-5 space-y-3" data-testid="charter-rules">
          {rules.map((r, i) => (
            <div key={i} className="flex items-start gap-3">
              <div className="mt-0.5 h-6 w-6 rounded-full bg-pro/10 text-pro flex items-center justify-center shrink-0">
                <Check className="w-4 h-4" />
              </div>
              <p className="text-sm text-ink leading-relaxed">{r}</p>
            </div>
          ))}
        </div>

        <p className="text-[11px] text-slate2 leading-relaxed px-1">
          À l&apos;étape suivante, vous choisirez votre formule&nbsp;: paiement à la demande (jetons)
          ou abonnement Premium. Vous pourrez changer de formule à tout moment depuis votre profil.
        </p>

        <label className="flex items-start gap-3 p-4 bg-white rounded-2xl border border-border cursor-pointer tap-scale">
          <Checkbox checked={ok} onCheckedChange={(v) => setOk(!!v)} data-testid="accept-charter-checkbox" />
          <span className="text-sm text-ink">J&apos;ai lu et j&apos;accepte la charte Besoin d&apos;un Pro.</span>
        </label>
      </div>

      <div className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-[480px] bg-white border-t border-border p-4">
        <Button
          disabled={!ok}
          onClick={() => nav("/register/pro", { state: { charter: true } })}
          className="w-full rounded-full bg-pro hover:bg-pro-hover text-white py-6 text-base font-semibold disabled:opacity-50"
          data-testid="continue-pro-signup-btn"
        >
          Continuer
        </Button>
      </div>
    </div>
  );
}
